import React from 'react';
import {Dropdown} from 'react-bootstrap';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import {SearchExportFormat} from '../search-types';
import './exportDropdownComponent.scss';
import {useTranslation} from 'react-i18next';
import {ExportToggles} from '../../config/config-types';
import {VerticalSeparator} from '../../common/verticalSeparator/verticalSeparator';
import {HibuTooltip} from '../../common/hibuTooltip/hibuTooltip';

type ReportDropdownInputProps = {
    onSelect: (format: SearchExportFormat) => void;
    exportToggles: ExportToggles;
};

interface Option {
    value: SearchExportFormat;
    text: string;
}

const options: Option[] = [
    {value: SearchExportFormat.HTML, text: 'search.export.html'},
    {value: SearchExportFormat.JSON, text: 'search.export.json'},
];

export const ReportDropdown = React.memo((props: ReportDropdownInputProps) => {
    const {t} = useTranslation();

    const enabledExportOptions: Option[] = options.filter((element) => props.exportToggles?.[element.value]);

    if (enabledExportOptions.length === 0) {
        return null;
    }

    if (enabledExportOptions.length === 1) {
        const singleOption = enabledExportOptions[0];
        return (
            <div id="export-wrapper">
                <VerticalSeparator/>
                <HibuTooltip tooltipKey={singleOption.text} placement="bottom" trigger="hover" hideOnClick>
                    <button id="export-button" type="button" onClick={() => props.onSelect(singleOption.value)}>
                        <SvgIcon icon={Icons.EXPORT} id="icon-export"/>
                    </button>
                </HibuTooltip>
            </div>
        );
    }

    return (
        <div id="export-wrapper">
            <VerticalSeparator/>
            <Dropdown id="export-dropdown">
                <HibuTooltip tooltipKey="search.export.tooltip" placement="bottom" trigger="hover" hideOnClick>
                    <Dropdown.Toggle id="export-dropdown-toggle">
                        <SvgIcon icon={Icons.EXPORT} id="icon-export"/>
                    </Dropdown.Toggle>
                </HibuTooltip>
                <Dropdown.Menu id="export-menu">
                    {enabledExportOptions.map(({value, text}) => (
                        <Dropdown.Item key={value} onClick={() => props.onSelect(value)}>
                            {t(text)}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
});
